import { Box } from '@factorialco/deprecated-design-system'
import { AccessForSelectFragment } from 'generated/resources/graphql'

import { AccessSelector } from 'modules/core/components/AccessSelector'
import useFilter from 'modules/core/components/Filter/base/useFilter'

const AccessFilterSelector = () => {
  const { value, onValueChange } = useFilter<AccessForSelectFragment[]>()

  return (
    <Box width="s400" flexDirection="column" overflowY="hidden" overflowX="hidden" hideScrollBar>
      <AccessSelector
        hideBorder
        alwaysOpen
        withAvatar
        width="s400"
        multiple
        value={value}
        onSelect={onValueChange}
        terminated={false}
      />
    </Box>
  )
}

export default AccessFilterSelector
